import {apiService} from '../apiService';

/** The signed-in person's training course progress, kept against their account. */
export const trainingCourseService = apiService.injectEndpoints({
    endpoints: (builder) => {
        return {
            getTrainingCourseProgress: builder.query({
                query: () => ({
                    url: '/training-course/progress'
                })
            }),
            getTrainingCourseReport: builder.query({
                query: () => ({
                    url: '/training-course/report'
                })
            }),
            saveTrainingCourseProgress: builder.mutation({
                query: (progress) => ({
                    url: '/training-course/progress',
                    method: 'PUT',
                    data: progress
                })
            })
        };
    }
});

export const {
    useGetTrainingCourseProgressQuery,
    useGetTrainingCourseReportQuery,
    useSaveTrainingCourseProgressMutation
} = trainingCourseService;
